// extracted by mini-css-extract-plugin
export default {"cc-checkbox":"_jTBQZwu","has-error":"ZIZHDIlT","cc-checkmark":"A4TOZufe","cc-checkbox-label":"vegQAU_k","cc-checkbox-text":"_0pOMP1t"};